export const LOCAL_ONBOARDING_COMPLETED_STORAGE_KEY =
  'local_onboarding_completed'
